@if(value) {
<div class="tw-max-w-lg">
  @if (editMode) {
  <form #locationForm="ngForm" class="tw-flex tw-flex-col tw-gap-2">
    @if(showTitle) {
    <mat-form-field>
      <mat-label>Address Title</mat-label>
      <input matInput name="title" type="text" [(ngModel)]="value.Title" (ngModelChange)="valueChanged()" />
    </mat-form-field>
    }
    <div class="tw-flex tw-items-end tw-gap-4">
      @if(postcodeReadonly){
      <div class="tw-flex tw-items-center tw-gap-2">
        <div class="tw-font-bold">{{ value.Postcode }}</div>
        @if(postcodeChangeable) {
        <button mat-button type="button" class="!tw-min-w-0 !tw-px-2" (click)="postcodeChange.emit()">
          <mat-icon>edit</mat-icon>
          Change
        </button>
        }
      </div>
      } @else{
      @if(addressLookup) {
      <div class="address-lookup">
        <mat-form-field class="tw-w-full" subscriptSizing="dynamic">
          <mat-label>Postcode</mat-label>
          <input matInput name="postcode" [(ngModel)]="value.Postcode" autocomplete="postal-code"
            (keyup.enter)="$event.preventDefault(); lookupAddresses()" />
          <button mat-icon-button matSuffix type="button" aria-label="Find address"
            [disabled]="addressLookupBusy" (click)="lookupAddresses()">
            <mat-icon>{{addressLookupBusy ? 'hourglass_top' : 'location_on'}}</mat-icon>
          </button>
        </mat-form-field>
        @if(addressResults.length) {
        <div class="address-lookup__float" role="listbox" aria-label="Choose delivery address">
          @for(address of addressResults; track $index) {
          <button type="button" role="option" (click)="selectLookupAddress(address)">
            <mat-icon>location_on</mat-icon><span>{{address.Title}}</span>
          </button>
          }
        </div>
        }
        @if(addressLookupMessage) { <small class="address-lookup__message">{{addressLookupMessage}}</small> }
      </div>
      } @else {
      <!-- Legacy postcode autocomplete is intentionally bypassed by BritPOS. -->
      <div class="tw-flex tw-flex-wrap tw-gap-2 tw-justify-between tw-items-end">
        <div class="tw-flex tw-flex-col">
          <label htmlFor="postcode">Postcode</label>
          <p-autoComplete id="postcode" name="postcode" [(ngModel)]="value.Postcode" [suggestions]="postcodes" appendTo="body"
            (completeMethod)="searchPostcode($event.query)" (onSelect)="onSelectPostcode($event)" (ngModelChange)="valueChanged()"></p-autoComplete>
        </div>
        @if(value.Postcode){
        <small class="tw-text-blue-500">{{value.City}}, {{value.County}}, {{value.Country}}</small>
        }
      </div>
      }
      }
    </div>

    <mat-form-field>
      <mat-label>@if(fetchHighway) {Fetching road name...} @else {Road}</mat-label>
      <input matInput name="highway" type="text" [(ngModel)]="value.Highway" pattern=".*\S.*"
        (focus)="roadFocused($event)"
        (ngModelChange)="valueChanged()" required="true" />
    </mat-form-field>
    @for (address of value.AddressLines; track $index) {
    <mat-form-field>
      <mat-label>
        @if(value.AddressLines?.length==1){Address{{ addressRequired ? "" : " (Optional)" }}} @else{Address Line
        {{ $index + 1 }}{{ !addressRequired || $index ? " (Optional)" : "" }}}
      </mat-label>
      <input matInput [name]="'address-' + $index" type="text" [required]="addressRequired && $index === 0"
        [pattern]="addressRequired && $index === 0 ? '.*\\S.*' : undefined"
        [(ngModel)]="value.AddressLines[$index]" (ngModelChange)="valueChanged()" />
    </mat-form-field>
    }
    <mat-form-field>
      <mat-label>Phone</mat-label>
      <input matInput id="phone" name="phone" type="text" pattern="^(0?\d{10})$" [(ngModel)]="value._phone"
        (onComplete)="valueChanged()" (onBlur)="valueChanged()" (ngModelChange)="valueChanged()" [required]="phoneRequired"
        placeholder="Enter a valid UK phone number" />
      <span matTextPrefix>+44&nbsp;</span>
      @if(value._phone && !value._phone.match('^(0?\d{10})$')) {
      <mat-error>Please enter valid UK phone number</mat-error>
      }
    </mat-form-field>
  </form>

  } @else {
  @if(showTitle && value.Title) {
  <strong>{{value.Title}}</strong>
  }
  <p>
    @for(line of value.AddressLines; track $index) {
    @if(line){<span>{{line}}, </span>}
    }
    <span>{{value.Highway}}, </span>
    <span>{{value.County || value.City}}, </span><span>{{value.Postcode}}</span>
  </p>
  @if(value.Phone) {
  <p>Phone number: {{value.Phone}}</p>
  }

  }


</div>
}
